import { render } from "./privacyPolicy.vue?vue&type=template&id=6045c38f"
import script from "./privacyPolicy.vue?vue&type=script&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__